{
  "defaultLanguage": "fr",
  "snackbarTimeout": 3000,
  "need_help_url": "https://support.bisom.fr/support/solutions/articles/103000311914-sau-r%C3%A9cup%C3%A9ration-du-bilan-via-le-code-challenge-https-bilan-bisom-fr-",
  "locales": [
    { "name": "fr_FR", "value": "fr_FR" },
    { "name": "en_EN", "value": "en_EN" }
  ],
  "timezones": [{ "name": "europe_paris", "value": "Europe/Paris" }],
  "status": [
    {
      "name": "SMUR",
      "value": "SMUR"
    },
    { "name": "AP", "value": "AP" },
    { "name": "SP", "value": "SP" }
  ],
  "validations": {
    "bilanNameMinSize": 5,
    "minSize": 1
  }
}
